// Tracks which chapter element is currently in the viewport's hot zone.
// Returns the id string of the most recently entered chapter, or the first
// chapter id when nothing has scrolled yet.

import React from 'react';

export function useChapterScrollSpy(chapterIds = [], { rootMargin = '-30% 0px -60% 0px' } = {}) {
    const [activeId, setActiveId] = React.useState(chapterIds[0] || null);

    // Depend on the ids' CONTENT, not the array's identity (callers pass a fresh
    // array each render), so the observer only re-attaches when the set changes.
    const chapterKey = chapterIds.join('|');

    React.useEffect(() => {
        if (!chapterIds.length || typeof IntersectionObserver === 'undefined') return undefined;
        const elements = chapterIds.map(id => document.getElementById(id)).filter(Boolean);
        if (!elements.length) return undefined;

        const observer = new IntersectionObserver((entries) => {
            entries.forEach(e => {
                if (e.isIntersecting) setActiveId(e.target.id);
            });
        }, { rootMargin });

        elements.forEach(el => observer.observe(el));
        return () => observer.disconnect();
        // chapterKey encodes chapterIds' content; intentional over array identity.
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [chapterKey, rootMargin]);

    return activeId;
}
